import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_KEY } from 'src/common/config/TextMessage';
import EditCard from './EditCard';

const appearance: any = {
  theme: 'stripe'
};
const options: any = {
  appearance
};

// const stripePromise = loadStripe(STRIPE_KEY);

// -------->>>>>>
let cachedStripePromise: Promise<any> | null = null;
const getStripe = () => {
  if (!cachedStripePromise) {
    cachedStripePromise = loadStripe(STRIPE_KEY);
  }
  return cachedStripePromise;
};
// -------->>>>>>

export default function EditPayment({
  handCloseModal,
  setCardDetails,
  closeBtn,
  setIsCardUpdated = (_: boolean) => {}
}) {
  const [message, setMessage] = useState(false);

  // -------->>>>>>
  const [stripePromise, setStripePromise] = useState<any>(null);
  useEffect(() => {
    // Only load the heavy Stripe JS library when this component actually mounts!
    // This fixes the Lighthouse performance issue caused by the global loadStripe.
    setStripePromise(getStripe());
  }, []);
  // -------->>>>>>

  const chooseMessage = (message) => {
    setMessage(message);
  };

  // -------->>>>>>
  if (!stripePromise) {
    return null; // Or a loading spinner
  }
  // -------->>>>>>

  return (
    <div>
      <Elements options={options} stripe={stripePromise}>
        <EditCard
          chooseMessage={chooseMessage}
          handCloseModal={handCloseModal}
          closeBtn={closeBtn}
          setCardDetails={setCardDetails}
          setIsCardUpdated={setIsCardUpdated}
        />
      </Elements>
    </div>
  );
}
